module.exports = __webpack_public_path__ + "img/icons BFr_19.6291d599.svg";